import { Component } from '@angular/core';
import { Globals } from '../../../../../globals';
import { NavController } from 'ionic-angular';
import { ArticlesServices } from '../../../../articles/services';
import { ArticlesListPage } from '../../../../articles/articles-list/articles-list';
import { HttpClient, HttpParams } from '@angular/common/http';

@Component({
    selector: 'page-home-articles',
    templateUrl: 'home-articles.html'
})


export class HomeArticlesPage {
    total_articles = 0;
    total_articles_no_fc = 0;
    total_articles_no_pvp = 0;
    get_analytics = false;

    constructor(public globals: Globals,
        public navCtrl: NavController,
        public http: HttpClient,
        private articlesServices: ArticlesServices) {
    }

    ngOnInit() {
        this.getAnalytics();
    }

    goToArticles() {
        this.globals.side_menu_active = 'dish';
        this.navCtrl.setRoot(ArticlesListPage);
        this.globals.side_menu_active_analytics = false;
        this.globals.open_side_menu = false;
    }

    async getAnalytics() {
        this.total_articles_no_pvp = 0;
        this.total_articles_no_fc = 0;
        this.total_articles = 0;
        if (this.articlesServices.get_articles) {
            this.total_articles = this.articlesServices.list_dishes_products_array.length;
            this.articlesServices.list_dishes_products_array.forEach(element => {
                if (element.price == undefined || element.price == 0) {
                    this.total_articles_no_pvp++;
                }
            });
            this.get_analytics = true;
        } else {
            const params = new HttpParams()
                .set('uid', this.globals.restaurant_uid)
                .set('tax', this.globals.RESTAURANT_TAX.toString());

            await this.http.post(this.globals.analytics_path + 'paginate/dishes_products_v2', params, {})
                .subscribe(async res => {
                    this.total_articles = res['list'].length;
                    res['list'].forEach(element => {
                        if (element.price == undefined || element.price == 0) {
                            this.total_articles_no_pvp++;
                        }
                    });
                    if (this.total_articles != 0) {
                        this.articlesServices.articles_array_tmp = res['list'];
                        this.articlesServices.getListDishesProductsMinMax();
                    }
                    this.get_analytics = true;
                });
        }

        const fcParams = new HttpParams().set('public_key', this.globals.public_key);
        this.http.post(this.globals.analytics_path + 'bidish/get_dishes_foodcost_percentatge', fcParams, {})
            .subscribe(res => {
                this.total_articles_no_fc = res['plats_sense_foodcost'];
            });
    }

    openLanding() {
        if (this.globals.so_mobile) {
            window.location.assign('https://ads.mycheftool.com/carta-y-menu-digital');
        } else {
            window.open('https://ads.mycheftool.com/carta-y-menu-digital', '_blank');
        }
    }
}


// WEBPACK FOOTER //
// ./src/pages/home/home-dashboard/home-cards/home-articles/home-articles.ts